<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="推广奖励管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
           <el-form-item label="会员姓名">
            <el-input v-model="params.PersonName" placeholder="请输入会员姓名" clearable />
          </el-form-item>
          <el-form-item label="奖励类型">
            <el-select v-model="params.RewardType" placeholder="请选择奖励类型" clearable>
              <el-option label="注册会员" :value="1"></el-option>
              <el-option label="消费" :value="0"></el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item label="奖励时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.RewardStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.RewardEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>

        </template>
        <template slot="table">
          <el-table-column prop="PersonName" label="会员姓名" />
          <el-table-column prop="RewardType" width="80px" label="奖励类型" align="center">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.RewardType == 1">注册会员</el-tag>
              <el-tag type="danger" v-else>会员消费</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="RewardMoney" label="奖励金额" />
          <el-table-column prop="RewardTime" label="奖励时间" />
           <el-table-column prop="Notices" label="备注" />
          
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
          PersonName: "",
          RewardType: null,
          RewardStarttime: null,
          RewardEndtime: null,
        },
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{PersonName:"李小姐",RewardType:1,RewardMoney:2,RewardTime:"2024-08-21 12:06:23",Notices:"会员编号:2024082100001"},{PersonName:"李小姐",RewardType:2,RewardMoney:2,RewardTime:"2024-08-21 14:05:20",Notices:"会员编号:2024082100001,订单号:O20240115033"}]});
      })
    },
     
    },
  };
  </script>